import { render, staticRenderFns } from "./CmgGroupOrderMenu.vue?vue&type=template&id=4324d382&scoped=true&lang=pug"
import script from "./cmg-group-order-menu.ts?vue&type=script&lang=ts&external"
export * from "./cmg-group-order-menu.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgGroupOrderMenu.vue?vue&type=style&index=0&id=4324d382&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4324d382",
  null
  
)

export default component.exports